<template>
    <div>
        <span class="">
            <span v-if="matchSummaryData" class="">{{ matchSummary }}</span>
        </span>
    </div>
</template>

<script>
    import { HubConnection } from '@aspnet/signalr';

    export default {
        name: 'MatchSummary',
        data() {
            return {
                matchSummary: null,
            }
        },
        props: {
            connection: HubConnection,
            sport: String,
            eventId: String,
            state: Array,
            matchSummaryData: Object
        },
        methods: {
            updateGamestate(updatedGamestate) {
                if (updatedGamestate !== null && updatedGamestate.FixtureID === this.eventId) {
                    this.matchSummary = updatedGamestate && updatedGamestate.GameState[0].MatchSummary;
                }
            },
        },
        mounted() {
            if (this.matchSummaryData && this.matchSummaryData.gameState[0] && this.matchSummaryData.gameState[0].matchSummary) {
                this.matchSummary = this.matchSummaryData.gameState[0].matchSummary;
            }

            if (this.connection) {
                this.connection.on(this.sport + "ms-rcv", (value) => {
                    if (value !== null) {
                        this.updateGamestate(JSON.parse(value));
                    }
                });
            }

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .sub-header {
        padding-top: 10px;
        padding-bottom: 10px;
        display: inline-block;
        width: 100%;
        font-size: 15px;
        background-color: #5c1b7b;
    }

    span.match-summary-text {
        padding-left: 10px;
        text-align: left;
    }

    span.match-facts {
        text-align: right;
        float: right;
        padding-right: 10px;
        background-color: #46246d;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 10px;
        margin-top: -10px;
        margin-bottom: -10px;
    }
</style>
